import React, {FC} from 'react';
import {Flex, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import styles from './Notification.module.scss';

export type NotificationProps = {
    message: React.ReactElement;
};

export const Notification: FC<NotificationProps> = ({message}) => {
    return (
        <Flex direction={'row'} componentClasses={styles.wrapper} justifyContent={'flex-start'}>
            <Icon
                componentClasses={styles.icon}
                icon={PriorityIcon.moreInfo}
                iconColor={'primary-700'}
            />
            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                {message}
            </Text>
        </Flex>
    );
};
